import React from "react";
import { PageLayout } from "shared";
import { useAppScope } from "master";
import { NotificationItems, NotificationsText } from ".";

export const Notifications = () => {
  const { lanSettings } = useAppScope();
  return (
    <PageLayout
      title={NotificationsText.Notifications[lanSettings?.lan || "en"]}
      breadcrumb={[
        { label: NotificationsText.Notifications[lanSettings?.lan || "en"] },
      ]}
    >
      <NotificationItems />
    </PageLayout>
  );
};
